import { render, staticRenderFns } from "./cardImage.vue?vue&type=template&id=b5c2b0da"
import script from "./cardImage.vue?vue&type=script&lang=js"
export * from "./cardImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports